function padTime(n: number) {
    return n.toString().padStart(2, "0");
}

export function shortTimeFormat(date: Date) {
    return `${date.getHours()}:${padTime(date.getMinutes())}:${padTime(date.getSeconds())}`;
}
